module.exports = {"652829100":"博湖镇","652829101":"本布图镇","652829200":"塔温觉肯乡","652829202":"乌兰再格森乡","652829203":"才坎诺尔乡","652829204":"查干诺尔乡","652829205":"博斯腾湖乡","652829501":"兵团二十五团"}


//////////////////
// WEBPACK FOOTER
// ./src/town/652829.json
// module id = 2874
// module chunks = 0